import React from "react";
import Dialog from "./dialog";
import { apiBaseUrl } from "../consts/api-url.const";
import { Description, DialogPanel, DialogTitle } from "@headlessui/react";

export const ReConnectSpotifyPopup = (props: any) => {
  const { setIsModalOpen, isModalOpen  } =
    props;

  const handleConnect = async () => {
     const authBaseUrl = apiBaseUrl;
          // Remember current page so we can return here after Spotify login
          const currentUrl = window.location.href;
          window.localStorage.setItem("postLoginRedirect", currentUrl);
          const redirectUrl = encodeURIComponent(currentUrl);
          window.location.href = `${authBaseUrl}/api/auth/login`;
  };
  return (
    <>
      <Dialog
        isOpen={isModalOpen}
        setIsOpen={setIsModalOpen}
        className="relative z-10"
      >
        <DialogPanel
          className="max-w-lg w-full space-y-4 bg-[#0E0E10] shadow-dialogShadow px-8 py-10 rounded-[20px]"
          style={{
            backgroundImage: "url('/image/dialog-bg.webp')",
            backgroundSize: "110%",
            backgroundPosition: "center top",
          }}
        >
          <DialogTitle className="text-2xl font-semibold text-center">
          Spotify Connection Required
          </DialogTitle>
          <Description className="text-white/75 text-center">
            Your Spotify session has expired. To continue using all features of the platform, please reconnect your Spotify account. This will ensure your profile functions correctly and any playlist or track actions remain seamless.
          </Description>
          <div className="!mt-8 text-center">
            <button
              className="button button--secondary button--with-icon footer-button p-3"
              onClick={handleConnect}
            >
              <img src="/image/Spoty-logo.webp" alt="Spotify Logo" title="Spotify Logo" width="35" height="35" loading="lazy" />
              Connect with Spotify
            </button>
          </div>
        </DialogPanel>
      </Dialog>
    </>
  );
};
